module.exports = __webpack_public_path__ + "static/media/monstermeat.5204062a.webp";